import { Capacitor } from '@capacitor/core';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.kynaixsports';
const APP_STORE_URL = 'https://apps.apple.com/us/app/kynaix-sports/id6761959059';

const GooglePlayIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
    <path d="M3.18 23.76c.37.21.8.22 1.2.03l12.9-7.19-2.88-2.89-11.22 10.05zM.5 1.68C.19 2.04 0 2.57 0 3.26v17.48c0 .69.19 1.22.51 1.58l.08.08 9.79-9.79v-.23L.58 1.6.5 1.68zM20.49 10.5l-2.74-1.53-3.08 3.08 3.08 3.08 2.76-1.54c.79-.44.79-1.65-.02-2.09zM4.38.24L17.28 7.43l-2.88 2.88L3.18.26C3.58.07 4.01.08 4.38.24z"/>
  </svg>
);

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
  </svg>
);

export default function StoreButtons({ className = '', size = 'default' }) {
  if (Capacitor.isNativePlatform()) return null;
  const isSmall = size === 'sm';

  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center gap-3 bg-black text-white rounded-xl font-medium transition-opacity hover:opacity-80 ${isSmall ? 'px-3 py-1.5 text-xs' : 'px-4 py-2.5 text-sm'}`}
      >
        <AppleIcon />
        <div className="flex flex-col leading-tight">
          <span className={`${isSmall ? 'text-[9px]' : 'text-[10px]'} opacity-75`}>Download on the</span>
          <span className={`${isSmall ? 'text-xs' : 'text-sm'} font-semibold`}>App Store</span>
        </div>
      </a>

      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center gap-3 bg-black text-white rounded-xl font-medium transition-opacity hover:opacity-80 ${isSmall ? 'px-3 py-1.5 text-xs' : 'px-4 py-2.5 text-sm'}`}
      >
        <GooglePlayIcon />
        <div className="flex flex-col leading-tight">
          <span className={`${isSmall ? 'text-[9px]' : 'text-[10px]'} opacity-75`}>Get it on</span>
          <span className={`${isSmall ? 'text-xs' : 'text-sm'} font-semibold`}>Google Play</span>
        </div>
      </a>
    </div>
  );
}
